import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  List,
  Modal,
  Popconfirm,
  Select,
  Skeleton,
  Tooltip,
  Typography,
} from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import {
  GetIPAddress,
  GetLicenseManagementSoftwares,
  axiosErrorMessages,
  updateServerLicense,
} from "../../../API/api";
import AddSoftware from "../../license/components/AddSoftware";
import axios, { AxiosError } from "axios";
interface Software {
  softwareName: string;
  version: string;
}
interface SoftwareId {
  softwareId: string;
  versionId: string;
}

interface AddEmployeeLicenseVersion {
  closeAddPopup: (data: any) => void;
  editDetails: any;
}
const EditServerLicense: React.FC<AddEmployeeLicenseVersion> = ({
  closeAddPopup,
  editDetails,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [addLicenseForm] = Form.useForm();
  const [ipAddress, setIpAddress] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAddSoftware, setIsAddSoftware] = useState<boolean>(false);
  const [selectedSoftwareList, setSelectedSoftwareList] = useState(
    editDetails.licenseSoftwares
  );
  const [editIndex, setEditIndex] = useState<number>();
  const [softwareId, setSoftwareId] = useState<number>(0);
  const [versionId, setVersionId] = useState<number>(0);

  const [editSoftwareDetails, setEditSoftwareDetails] = useState({});
  const [selectedSoftwareListId, setSelectedSoftwareListId] = useState<any>([]);
  const [softwareList, setSoftwareList] = useState([]);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const GetOsList = async () => {
    try {
      setIsLoading(true);
      const response = await GetLicenseManagementSoftwares();

      setSoftwareList(response.data);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  const onSaveStatusHandler = (formData: any) => {
    if (formData.assetTagId.trim() && formData.serverName.trim()) {
      // Update the state with the new software entry
      if (selectedSoftwareListId.length === 0) {
        enqueueSnackbar("Select softwares for the server", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      } else {
        const updateData = {
          ...formData,

          serverAssetId: editDetails.serverAssetId,
          assetSoftwareList: selectedSoftwareListId,
        };
        updateServerLicense(updateData)
          .then((response: any) => {
            enqueueSnackbar("Updated Successfully", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            closeAddPopup(true);
          })
          .catch((error: any) => {
            let errorMsg;
            if (axios.isAxiosError(error)) {
              const axiosError = error as AxiosError;
              errorMsg = axiosErrorMessages(axiosError);
            } else {
              errorMsg = error.message;
            }
            enqueueSnackbar(errorMsg, {
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
          });
      }
    } else
      enqueueSnackbar("Enter Mandatory Values", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
  };
  useEffect(() => {
    if (editDetails && ipAddress.length > 0) setFormData();
  }, [ipAddress]);

  const setFormData = () => {
    const filteredArray: any = ipAddress.filter(
      (item: { label: string; value: number }) =>
        item.label === editDetails.ipAddress
    );

    addLicenseForm.setFieldsValue({
      serverName: editDetails.serverName,
      ipAddressId: filteredArray[0].value,
      assetTagId: editDetails.assetTagId,
    });
    // Extracting relevant information
    //joining both license and other softwares
    const softwares = [
      ...editDetails.licenseSoftwares,
      ...(editDetails.otherSoftwares || []),
    ];
    const transformedArray = softwares.flatMap((software: any) => {
      if (software.softwareVersions.length > 0) {
        return software.softwareVersions.map((version: any) => ({
          softwareId: software.softwareId,
          softwareName: software.softwareName,
          isOs: software.isOs,
          softwareVersions: [version],
        }));
      } else {
        return [software];
      }
    });

    const softwareInfoCollection: any = transformedArray
      .filter((software: any) => software.softwareVersions.length > 0)
      .map((software: any) => {
        const versionNamesString = software.softwareVersions
          .map((version: any) => version.versions)
          .join(", ");
        const softwareNameDummy: any = softwareList.find(
          (softwareSearch: any) =>
            softwareSearch.softwareId === software.softwareId
        );

        return {
          softwareName: softwareNameDummy.softwareName,
          softwareId: software.softwareId,
          versionName: versionNamesString,
          isOs: software.isOs,
        };
      });

    const softwareIdCollection: any = transformedArray
      .filter((software: any) => software.softwareVersions.length > 0)
      .map((software: any) => {
        return {
          softwareId: software.softwareId,
          versionId: software.softwareVersions.map(
            (version: any) => version.versionId
          )[0],
          isOs: software.isOs,
        };
      });
    setSelectedSoftwareListId(softwareIdCollection);

    // setSelectedSoftwareList(softwareInfoCollection);

    if (softwareList.length > 0) {
      const data1 = softwareInfoCollection.map((item: any) => {
        const softwareNameDummy: any = softwareList.find(
          (software: any) => software.softwareId === item.softwareId
        );
        if (softwareNameDummy)
          return {
            ...item,
            softwareName: softwareNameDummy.softwareName,
          };
      });
      setSelectedSoftwareList(data1);
    }
  };
  const filterOption = (
    input: string,
    option?: { label: string; value: number }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  useEffect(() => {
    GetOsList();
    fetchIpList();
  }, []);
  const onClosePopup = () => {
    setIsOpen(false);
    closeAddPopup(true);
  };
  const fetchIpList = async () => {
    try {
      setIsLoading(true);
      const response = await GetIPAddress();
      const newData = response.data.map((employee: any, index: number) => ({
        value: employee.ipAddressId,
        label: employee.ipAddress,
      }));
      setIpAddress(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // enqueueSnackbar(error, {
      //   variant: "error",
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setIsLoading(false);
    }
  };

  const onClose = () => setIsAddSoftware(false);
  const populateListData = (formData: any) => {
    setIsAddSoftware(false);
    const result: any = getSoftwareAndVersion(formData);
    let editValue: any = undefined;
    if (isEdit) {
      editValue = editIndex;
    }
    const newListArray = selectedSoftwareList.filter(
      (_: any, index: number) => index !== editValue
    );
    const newIdListArray = selectedSoftwareListId.filter(
      (_: any, index: number) => index !== editValue
    );
    setSelectedSoftwareList(newListArray);
    setSelectedSoftwareListId(newIdListArray);

    const uniqueArray: Software[] = removeDuplicates([...newListArray, result]);
    setSelectedSoftwareListId(
      removeDuplicateIds([...newIdListArray, formData])
    );

    // Update the state with the new array
    // setSelectedSoftwareListId(
    //   Array.from(new Set([...newIdListArray, formData]))
    // );
    setSelectedSoftwareList(uniqueArray);
  };
  const removeDuplicateIds = (arr: any) => {
    const uniqueMap = new Map<string, SoftwareId>();
    arr.forEach((software: any) => {
      const key = `${software.softwareId}_${software.versionId}`;
      uniqueMap.set(key, software);
    });
    return Array.from(uniqueMap.values());
  };

  const removeDuplicates = (arr: any) => {
    const uniqueMap = new Map<string, Software>();
    arr.forEach((software: any) => {
      const key = `${software.softwareName}_${software.versionName}`;
      uniqueMap.set(key, software);
    });
    return Array.from(uniqueMap.values());
  };

  // Function to get software name and version based on softwareId and versionId
  const getSoftwareAndVersion = (formData: {
    softwareId: number;
    versionId: number;
  }) => {
    const software: any = softwareList.find(
      (item: any) => item.softwareId === formData.softwareId
    );
    if (software) {
      const version = software.versions.find(
        (v: any) => v.versionId === formData.versionId
      );

      if (version) {
        return {
          softwareId: software.softwareId,

          softwareName: software.softwareName,
          versionName: version.version,
          isOs: software.isOs,
        };
      }
    }

    return undefined;
  };
  const removeItem = (rowData: any, indexToRemove: number) => {
    const updatedSoftwareList = selectedSoftwareList.filter(
      (software: any) =>
        !(
          software.softwareName === rowData.softwareName &&
          software.versionName === rowData.versionName
        )
    );

    // Check if the index is within the bounds of the array
    // Use filter to create a new array with the item at the specified index removed
    const newArray = selectedSoftwareListId.filter(
      (_: any, index: number) => index !== indexToRemove
    );

    setSelectedSoftwareListId(newArray);
    setSelectedSoftwareList(updatedSoftwareList);
  };
  const handleEditVersion = (rowData: any, index: number) => {
    setEditIndex(index);
    const softwareId: any = softwareList.find(
      (software: any) => software.softwareName === rowData.softwareName
    );
    setSoftwareId(softwareId.softwareId);

    if (softwareId)
      setVersionId(
        softwareId.versions.find(
          (version: any) => version.versions === rowData.versionNames
        ).versionId
      );
    setIsEdit(true);
    setEditSoftwareDetails(rowData);
    setIsAddSoftware(true);
  };
  return (
    <>
      <Modal
        maskClosable={false}
        footer={null}
        title="Edit Server License Provision"
        onCancel={onClosePopup}
        open={isOpen}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 12 }}
          style={{ maxWidth: 1000 }}
          onFinish={onSaveStatusHandler}
          autoComplete="off"
          form={addLicenseForm}
        >
          <Form.Item
            rules={[{ required: true, message: "Enter Name" }]}
            name="serverName"
          >
            <Input placeholder="Server Name" />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Enter Name" }]}
            name="assetTagId"
          >
            <Input placeholder="Asset Tag Id" />
          </Form.Item>
          <Button
            type="text"
            onClick={() => {
              setIsEdit(false);
              setIsAddSoftware(true);
            }}
            icon={<PlusOutlined />}
          >
            Add Software
          </Button>
          <List
            size="small"
            className="demo-loadmore-list"
            itemLayout="horizontal"
            dataSource={selectedSoftwareList}
            renderItem={(item: any, index) => (
              <List.Item
                actions={[
                  <>
                    <Typography.Link
                      onClick={() => handleEditVersion(item, index)}
                    >
                      {" "}
                      <EditOutlined />
                    </Typography.Link>
                    <Popconfirm
                      title="Do you want to remove the version?"
                      onConfirm={() => removeItem(item, index)}
                    >
                      <a>
                        {" "}
                        <DeleteOutlined />
                      </a>
                    </Popconfirm>
                  </>,
                ]}
              >
                <Skeleton avatar title={false} loading={item.loading} active>
                  <List.Item.Meta
                    title={
                      <Tooltip placement="topLeft" title={item.softwareName}>
                        {(item.softwareName && item.softwareName.length) > 20
                          ? `${item.softwareName.slice(0, 20)}...`
                          : item.softwareName}
                      </Tooltip>
                    }
                  />
                  <List.Item.Meta
                    title={
                      <Tooltip placement="topLeft" title={item.versionName}>
                        {item.versionName && item.versionName.length > 20
                          ? `${item.versionName.slice(0, 20)}...`
                          : item.versionName}
                      </Tooltip>
                    }
                  />
                </Skeleton>
              </List.Item>
            )}
          />

          <Button className="pm-btn" type="primary" htmlType="submit">
            Save
          </Button>
        </Form>
      </Modal>
      {isAddSoftware && (
        <AddSoftware
          softwareId={softwareId}
          versionId={versionId}
          isEdit={isEdit}
          onClose={onClose}
          populateListData={populateListData}
          editSoftwareDetails={undefined}
        />
      )}
    </>
  );
};

export default EditServerLicense;
